import BillableForm from "@/modules/work/billables/details/form";
import { EvtHeader } from "components/header";
import { useParams } from "react-router-dom";
import { useJob } from "@/modules/work/jobs/context";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const CreateBillable = () => {
  const { jobId } = useParams();

  const { job, config } = useJob();

  const navigate = useNavigate();

  useEffect(() => {
    if (job) {
      if (!config) {
        navigate(-1);
      }
    }
  }, [job]);

  return (
    <div className="flex-1">
      <EvtHeader title="Create Billable" />
      <div className="p-6 max-w-md">
        <BillableForm jobId={jobId} job={job} type={job?.type} />
      </div>
    </div>
  );
};

export default CreateBillable;
